import { useEffect } from "react";
import type { ChangeNotification } from "../api/generated/contracts";
import { realtimeClient } from "./signalrClient";
import type { InvalidationHandler } from "./signalrClient";

/**
 * Subscribes `onInvalidated` to the push channel for the lifetime of the calling component.
 * A write elsewhere broadcasts a ChangeNotification (entity keys + change kind, never entity
 * data - decomposition.md section 8.5), and the handler's job is to re-enter the ordinary read
 * chain (refetch), never to apply the notification's payload directly, since none was sent.
 */
export function useInvalidation(onInvalidated: InvalidationHandler, filterEntityType?: string): void {
  useEffect(() => {
    realtimeClient.start();

    const handler: InvalidationHandler = (notification: ChangeNotification) => {
      if (filterEntityType && notification.entityType !== filterEntityType) return;
      onInvalidated(notification);
    };

    return realtimeClient.subscribe(handler);
  }, [onInvalidated, filterEntityType]);
}
